import { HttpErrorService } from '@/services/HttpError.service'
import { searchErrorHandbook } from '@/models/Errors'
import { HttpService } from '@/services/Http.service'
import type { SearchHint, SearchParams, SearchResult } from '~/models'

export class SearchService {
  private httpErrorService: HttpErrorService<keyof typeof searchErrorHandbook>
  private httpService: HttpService
  private endpoint = '/search'

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(searchErrorHandbook, 'search')
  }

  async getSearchHints(keyword: string) {
    const url = '/quick-search'

    return await this.httpService
      .get<SearchHint>(url, {
        fetchConfig: { params: { keyword } },
        requestConfig: {
          generalUrlId: url,
          cancellable: true,
          forceRequest: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async search(params: SearchParams) {
    return await this.httpService
      .get<SearchResult>(this.endpoint, {
        fetchConfig: {
          params,
        },
        requestConfig: {
          forceRequest: true,
          cancellable: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, this.endpoint)
      })
  }
}
